import {useState, useEffect, useCallback, useRef} from "react"
import cn from "classnames"

import {
  PrevButton,
  NextButton,
  ToggleFullScreenButton,
} from "./EmblaCarousel_Buttons"
import useEmblaCarousel from 'embla-carousel-react'

const EmblaCarousel = ({slides}) => {
  const containerRef = useRef()
  const [emblaRef, emblaApi] = useEmblaCarousel({loop: false})
  const [isFullScreen, setIsFullScreen] = useState(false)

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [
    emblaApi,
  ])
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [
    emblaApi,
  ])

  function toggleFullScreen() {
    let elem = containerRef.current

    if (!document.fullscreenElement) {
      setIsFullScreen(true)
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
      }
    } else {
      document.exitFullscreen()
      setIsFullScreen(false)
    }
  }

  useEffect(() => {
    document.onfullscreenchange = function (_event) {
      if (
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      ) {
        setIsFullScreen(false)
      }
    }
  }, [])

  return (
    <div ref={containerRef} className="w-full h-full">
      <div ref={emblaRef} className="relative h-full overflow-hidden">
        <div className="flex h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={cn(
                {
                  block: !isFullScreen,
                  "flex justify-center items-center": isFullScreen,
                },
                "h-full min-w-full"
              )}
            >
              {/* className here is needed for Safari (otherwise picture is not full heigh) */}
              <picture className="flex h-full">
                <source srcSet={slide.url} type="image/webp" />
                <img
                  className={cn({
                    "min-h-full min-w-full object-cover": !isFullScreen,
                    "max-h-my-100vh max-w-my-100vw": isFullScreen,
                  })}
                  src={slide.url}
                  alt={slide.alternativeText}
                />
              </picture>
            </div>
          ))}
        </div>
        <PrevButton
          onClick={scrollPrev}
          enabled={emblaApi && emblaApi.canScrollPrev()}
        />
        <NextButton
          onClick={scrollNext}
          enabled={emblaApi && emblaApi.canScrollNext()}
        />
        <ToggleFullScreenButton onClick={toggleFullScreen} />
      </div>
    </div>
  )
}

export default EmblaCarousel
